import { SvgIcon, SvgIconProps } from '@mui/material';
import { icons } from 'lucide-react';
import { memo } from 'react';

export type IconProps = {
  name: keyof typeof icons;
  className?: string;
  strokeWidth?: number;
} & Omit<SvgIconProps, 'component'>;

export const Icon = memo(({ name, sx, strokeWidth, ...props }: IconProps) => {
  const IconComponent = icons[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <SvgIcon
      component={IconComponent}
      sx={{
        width: 16,
        height: 16,
        ...sx,
      }}
      fontSize='small'
      {...props}
      strokeWidth={strokeWidth || 2.5}
    />
  );
});

Icon.displayName = 'Icon';
